const goods=[
"Books",
"Clothing",
"Electronics",
"Furniture",
"Jewelery",
"Gaming",
"Lawn & Gardening",
"Health & Beauty",
"Pets",
"Sports and Equipment",
"Vehicles"
]

const service =[
"Beauty",
"Child Care",
"Creative",
"Education",
"Electronic & Web",
"Gardening & Landscaping",
"Home Care",
"Labor",
"Health",
"Pets",
"Skilled"
]

const spaces =[
"Co-working",
"Events",
"Hospitality",
"Networking",
"Outdoors",
"Performance",
"Photo and Fillm",
"Pop-Ups",
"Sports",
"Warehouse",
"Weddings",
"Worship"
]

module.exports={goods,service,spaces}